import NP, {EventArgs, ValueChangedEventArgs} from "../../1. Core/NP";
import Control from "../../1. Core/Control";
import TopAppBar from "../../1. Core/Controls/TopAppBar/TopAppBar";
import Menu from "../../1. Core/Controls/Menu/Menu";
import Dialog from "../../1. Core/Controls/Dialog/Dialog";
import {ListBoxItemArgs} from "../../1. Core/Controls/ListBox/ListBox";
import CreateUserDlg from "./CreateUserDlg";
import TextField from "../../1. Core/Controls/TextField/TextField";
import {ServerAPI} from "../../1. Core/ServerAPI";
import {IUserInfo} from "../../1. Core/UserInfo";
import DataTable from "../../1. Core/Controls/DataTable/DataTable";
import {ITournament, IWidget} from "../../10. Battle/Util";
import CheckBox from "../../1. Core/Controls/CheckBox/CheckBox";
import "./UsersPanel.scss";
import Label from "../../1. Core/Controls/Label/Label";
import UserFeatureDialog from "./UserFeatureDialog";
import NumField from "../../1. Core/Controls/TextField/NumField";
import UserCards from "../../5. Fantasy/UserCards";
import {PageMode} from "../../10. Battle/types";
import Button from "../../1. Core/Controls/Button/Button";
import IconToggleButton from "../../1. Core/Controls/IconToggleButton/IconToggleButton";
import UsersFilterPanel from "./UsersFilterPanel";


export default class UsersPanel extends Control {
	private _Offset: number;
	private _Count: number;
	private _FilterText: string;
	private _topAppBar: TopAppBar;
	private _list: DataTable;
	public _contextMenu: Menu;
	private _availableTournamentsTable: DataTable;
	private _onlyAthletesFromTournaments: CheckBox;
	private availableWidgetsTableAthlete: DataTable;
	private availableWidgetsTableBattleBox: DataTable;
	private availableWidgetsTableBattleMMA: DataTable;
	private _filtersPanel: UsersFilterPanel;
	private _dataWithFiltersNode: HTMLElement;
	drillCardListPanel: UserCards
	private _OpenedItemId: number;

	_Mode: PageMode

	constructor(settings?: object)
	{
		super(settings);
		this._render();
	}

	_initFields(settings: object)
	{
		this._Mode = PageMode.users
		this._OpenedItemId = null;
		super._initFields(settings);
	}

	_render()
	{
		this.np_render();

		this._Offset = 0;
		this._Count = 100;
		this._FilterText = "";
		this._topAppBar = new TopAppBar({
			Caption: this._Mode == PageMode.users ? 'Users' : 'Players',
			ParentNode: this._root,
			Class: 'top-app-bar--no-shadow top-app-bar--light library-box-list__app-bar',
			ShowSearchButton: true,
			EvHideSearch: () => this.filterItems(null),
			EvSearch: (s: TopAppBar, e: ValueChangedEventArgs) => this.filterItems(e.Value),
			RightItems: [{
				ToolTip: NP.RM.getString('AddSingleUser'),
				FontImage: NP.FontImages.add,
				EvClick: () =>
				{
					(new CreateUserDlg({
						AutoDestroy: true,
						EvUserCreated: () => this.refresh()
					})).show();
				}
			}]
		});

		if (this._Mode == PageMode.players)
            this._topAppBar.addItem(new IconToggleButton({
                FontImage: NP.FontImages.tune,
                Value: 'Filters',
                EvClick: (btn: IconToggleButton) =>
                {
                    btn.setData(!btn.getData())
                    this._filtersPanel.setIsVisible(!this._filtersPanel.getIsVisible());
                    this.setWidth(this._Width);
                }
            }));

		let columns = this._Mode == PageMode.users ? [{
				 Content: "Id",
				 PropertyContent: 'Id',
				 Width: '50px'
			 }, {
				 Content: NP.RM.getString('Name'),
				 PropertyContent: 'Name',
				 Width: 'calc(100% - 50px - 200px - 100px - 100px - 150px)'
			 }, {
				 Content: 'Role',
				 PropertyContent: 'Role',
				 Width: '100px'
			 }] :
			 [{
				 Content: "Id",
				 PropertyContent: 'Id',
				 Width: '70px'
			 }, {
				 Content: NP.RM.getString('Name'),
				 PropertyContent: 'Name',
				 Width: 'calc(100% - 50px - 200px - 100px - 100px - 100px  - 150px - 50px - 150px)'
			 }, {
				 Content: 'SubStartDate',
				 PropertyContent: 'SubStartDate',
				 Width: '150px'
			 },{
				 Content: 'SubCancelDate',
				 PropertyContent: 'SubCancelDate',
				 Width: '150px'
			 }, {
				 Content: 'GymRating',
				 PropertyContent: 'gymRating',
				 Width: '100px'
			 }, {
				 Content: 'Level',
				 PropertyContent: 'currentLevel',
				 Width: '50px'
			 }, {
				 Content: 'PTS',
				 PropertyContent: 'PTS',
				 Width: '100px'
			 }, {
				 Content: 'Coins',
				 PropertyContent: 'Coins',
				 Width: '100px'
			 }, {
				 Content: 'HasFCM',
				 PropertyContent: 'HasFCM',
				 Width: '100px'
			 }, {
				 Content: 'Device',
				 PropertyContent: 'deviceInfo',
				 Width: '100px'
			 }, {
				 Content: 'Created',
				 PropertyContent: 'RegisterDate',
				 Width: '170px'
			 },{
				 Content: 'LastActivity',
				 PropertyContent: 'LastActivity',
				 Width: '150px'
			 }];



		let exPag = document.createElement('div')
		exPag.classList.add('export-node')
		if (this._Mode == PageMode.players) {
			new Button({
				Content: 'Export',
				ParentNode: exPag,
				EvClick: () => {
					NP.downloadFile(`/ui-api/users/export-players`);
				}
			})
		}

		this._dataWithFiltersNode = NP.createNode(this._root, 'data-with-filters-container');

		this._list = new DataTable({
			ParentNode: this._dataWithFiltersNode,
			ShowPaginator: true,
			EnableSort: false,
			ExPaginatorNode: exPag,
			EvPaginatorLeftClick: () =>
			{
				this._Offset -= this._Count;
				this.refresh();
			},
			EvPaginatorRightClick: () =>
			{
				this._Offset += this._Count;
				this.refresh();
			},
			Class: 'app-list--avatars',
			ShowSettingsButton: true,
			Columns: columns,
			EvItemClick: (s: object, e: { Item: IUserInfo }) =>
			{
				this.showCardList(e.Item.Id)
			},
			EvItemContextMenu: (sender: Control, args: EventArgs) =>
			{
				this._getContextMenu().setData(args.Item);
				this._getContextMenu().showContextMenu(args.Event);
			}
		});

		this._filtersPanel = new UsersFilterPanel({
			ParentNode: this._dataWithFiltersNode,
			Width: 280,
			EvFilterSortChanged: () => this.refresh(),
			EvSendNotificationClick: () => {
				(new Dialog({
					Caption: 'Send notification to Players',
					ShowHeader: true,
					Content: [
						new TextField({FloatingLabel: 'Title'}),
						new TextField({FloatingLabel: 'Body'})
					],
					EvOkButtonClick: async (dlg: Dialog) =>
					{
						await ServerAPI.post(`/fantasy/sendNotificationToPlayers`, {
							title: dlg.getContent()[0].getValue(),
							body: dlg.getContent()[1].getValue(),
							users: {
								filterText: this._FilterText || '',
								filterData: this._filtersPanel.getFilterData()
							}
						})
						this.refresh();
					}
				})).show()
			}
		});

		this._filtersPanel.setIsVisible(false)
	}

	showCardList(userId: number)
	{
		NP.updateBrowserUrlString(true, PageMode.users, userId);

		this._topAppBar.setIsVisible(false)
		this._list.setIsVisible(false)

		this.drillCardListPanel = new UserCards({
			ParentNode: this._root,
			UserId: userId,
			Width: this._Width,
			Height: this._Height - 44,
			EvClosed: () =>
			{
				NP.updateBrowserUrlString(true, PageMode.users, null);
				this.drillCardListPanel.destroy()
				this._topAppBar.setIsVisible(true)
				this._list.setIsVisible(true)
			}
		})
		this._filtersPanel.setIsVisible(false)
	}

	getTopAppBar()
	{
		return this._topAppBar;
	}

	_getContextMenu()
	{
		let items = this._Mode == PageMode.users ? [{
				 RK: 'LogInAsUser',
				 Value: 'LogInAsUser'
			 }, {IsSeparator: true}, {
				 RK: 'AvailableTournaments',
				 Value: 'AvailableTournaments'
			 }, {
				 RK: 'AvailableWidgets',
				 Value: 'AvailableWidgets'
			 }, {
				 RK: 'Features',
				 Value: 'Features'
			 }, {IsSeparator: true}, {
				 RK: 'ChangeEmail',
				 Value: 'ChangeEmail'
			 }, {
				 RK: 'Delete',
				 Value: 'DeleteUser'
			 }] :
			 [{
				 Content: 'Add coins',
				 Value: 'AddCoins'
			 }, {
				 Content: 'Send notification',
				 Value: 'SendNotification'
			 },
				 {IsSeparator: true}, {
				 RK: 'ChangeEmail',
				 Value: 'ChangeEmail'
			 }, {
				 RK: 'Delete',
				 Value: 'DeleteUser'
			 }];


		return this._contextMenu || (this._contextMenu = new Menu({
			Items: items,
			EvItemSelected: this._onSettingsMenuItemSelected.bind(this)
		}))
	}


	async _onSettingsMenuItemSelected(sender: Menu, args: ListBoxItemArgs)
	{
		const selectedUser = sender.getData() as IUserInfo;
		switch (args.Item.getValue())
		{
			case 'SendNotification':
				(new Dialog({
					Caption: 'Send notification',
					ShowHeader: true,
					Content: [
						new TextField({FloatingLabel: 'Title'}),
						new TextField({FloatingLabel: 'Body'})
					],
					EvOkButtonClick: async (dlg: Dialog) =>
					{
						await ServerAPI.post(`/fantasy/sendNotification/${selectedUser.Id}`, {
							title: dlg.getContent()[0].getValue(),
							body: dlg.getContent()[1].getValue()
						})
						this.refresh();
					}
				})).show()
				break;

			case 'AddCoins':
				(new Dialog({
					Caption: 'Add coins',
					ShowHeader: true,
					Content: new NumField({
						FractionCount: 0,
						Min: 1,
						Max: 1000000,
						Value: 10
					}),
					EvOkButtonClick: async (dlg: Dialog) =>
					{
						let value = dlg.getContent().getValue()
						await ServerAPI.post(`/coins/addCoins/${selectedUser.Id}/${value}`)
						this.refresh();
					}
				})).show()
				break;
			case 'Features':
				(new UserFeatureDialog({
					User: selectedUser
				})).show()
				break;
			case 'DeleteUser':

				NP.showConfirm({
					Content: 'Are you sure you want to delete this user?',
					EvOkButtonClick: () => ServerAPI.delet(`/users/${selectedUser.Id}`)
						 .then(() => this.refresh())
				});
				break;
			case 'LogInAsUser':
				await ServerAPI.post(`/users/loginas/${selectedUser.Id}`);
				window.location.href = '/'
				break;
			case 'ChangeEmail':
				(new Dialog({
					Content: new TextField({FullWidth: true}),
					ShowHeader: true,
					Caption: 'Change email',
					EvOkButtonClick: (dlg: Dialog) => NP.showConfirm({
						Content: NP.RM.getString("ChangeEmailConfirm").replace("{0}", selectedUser.Email).replace("{1}", dlg.getContent().getValue()),
						EvOkButtonClick: async () =>
						{
							await ServerAPI.post(`/users/${selectedUser.Id}`, {
								...selectedUser,
								email: dlg.getContent().getValue()
							})
							this.refresh();
						}
					})
				})).show();
				break;
			case 'AvailableTournaments':
				let isOnlyAthletesFromTournaments = await ServerAPI.get<boolean>(`/users/isOnlyAthletesFromTournaments/${selectedUser.Id}`)

				let tournaments = await ServerAPI.get<ITournament[]>(`/tournaments/getTournamentsForUser/${selectedUser.Id}`)
				let columns = [{
					Content: NP.RM.getString('Name'),
					Width: '100%',
					PropertyContent: 'Name'
				}];

				let container = document.createElement("div");
				container.className = "available-tournaments-dlg__container";

				this._onlyAthletesFromTournaments = new CheckBox({
					Content: NP.RM.getString('ShowOnlyParticipantsOfTournaments'),
					Value: 'ShowOnlyParticipantsOfTournaments',
					ParentNode: container,
					Checked: isOnlyAthletesFromTournaments,
					Class: "available-tournaments-dlg__only-athletes-from-tournaments"
				});

				this._availableTournamentsTable = new DataTable({
					Class: 'available-tournaments-dlg__tournaments-table app-list--avatars mdc-data-table--margin data-table-battle',
					ParentNode: container,
					MultiSelect: true,
					Columns: columns,
					ShowPaginator: false,
					Rows: tournaments,
					IsRowSelected: (row: ITournament) => row.IsAvailable,
				});

				(new Dialog({
					Width: 'auto',
					Content: container, //this._availableTournamentsTable,
					ShowHeader: true,
					Caption: NP.RM.getString("AvailableTournaments"),
					EvOkButtonClick: this._getAvailableTournamentsOkClick(selectedUser.Id)
				})).show();


				break;
			case 'AvailableWidgets':
			{
				let widgets: IWidget[] = await ServerAPI.get(`/widget/getInternalWidgetsForUser/${selectedUser.Id}`);

				let columns = [{
					Content: NP.RM.getString('Name'),
					Width: '100%',
					PropertyContent: 'Name'
				}];

				let container = document.createElement("div");
				container.className = "available-widgets-dlg__container";

				let lbl = new Label({
					ParentNode: container,
					RK: 'AthleteWidgets',
					Class: 'available-widgets-dlg__label available-widgets-dlg__label-athlete-widgets'
				});

				this.availableWidgetsTableAthlete = new DataTable({
					Class: 'available-widgets-dlg__widgets-table app-list--avatars mdc-data-table--margin data-table-battle',
					ParentNode: container,
					MultiSelect: true,
					Columns: columns,
					ShowPaginator: false,
					Rows: widgets.filter(x => x.Type === "Athlete"),
					IsRowSelected: (row: ITournament) => row.IsAvailable,
				});

				lbl = new Label({
					ParentNode: container,
					RK: 'BattleWidgets',
					Class: 'available-widgets-dlg__label available-widgets-dlg__label-battle-widgets'
				});

				lbl = new Label({
					ParentNode: container,
					RK: 'BattleWidgetsBox',
					Class: 'available-widgets-dlg__label available-widgets-dlg__label-battle-widgets-box'
				});

				this.availableWidgetsTableBattleBox = new DataTable({
					Class: 'available-widgets-dlg__widgets-table app-list--avatars mdc-data-table--margin data-table-battle',
					ParentNode: container,
					MultiSelect: true,
					Columns: columns,
					ShowPaginator: false,
					Rows: widgets.filter(x => x.Type === "Battle" && x.BattleType === "Box"),
					IsRowSelected: (row: ITournament) => row.IsAvailable,
				});

				lbl = new Label({
					ParentNode: container,
					RK: 'BattleWidgetsMMA',
					Class: 'available-widgets-dlg__label available-widgets-dlg__label-battle-widgets-mma'
				});

				this.availableWidgetsTableBattleMMA = new DataTable({
					Class: 'available-widgets-dlg__widgets-table app-list--avatars mdc-data-table--margin data-table-battle',
					ParentNode: container,
					MultiSelect: true,
					Columns: columns,
					ShowPaginator: false,
					Rows: widgets.filter(x => x.Type === "Battle" && (x.BattleType === "MMA" || x.BattleType === "KB")),
					IsRowSelected: (row: ITournament) => row.IsAvailable,
				});

				(new Dialog({
					Width: 'auto',
					Content: container,
					ShowHeader: true,
					Caption: NP.RM.getString("AvailableWidgets"),
					EvOkButtonClick: this.getAvailableWidgetsOkClick(selectedUser.Id)
				})).show();

				break;
			}
		}
	}

	_getAvailableTournamentsOkClick = (userId: number) => () =>
	{
		let rows = this._availableTournamentsTable.getSelection();
		let allRows = this._availableTournamentsTable.getRows();
		let selectedIds: number[];
		let onlyAthletesFromTournaments = this._onlyAthletesFromTournaments.getChecked();
		if (rows)
		{
			if (rows.length === allRows.length || rows.length === 0)
				selectedIds = [];
			else
			{
				let ids = rows.map(x => Number.parseInt(x.Id));
				if (ids.every(x => !isNaN(x)))
				{
					selectedIds = ids;
				}
			}
		}
		if (selectedIds != undefined)
		{
			ServerAPI.post(`/tournaments/setTournamentsForUser/${userId}?onlyAthletesFromTournaments=${onlyAthletesFromTournaments}`, selectedIds)
		}
	}

	getAvailableWidgetsOkClick = (userId: number) => () =>
	{
		let rows = [
			...this.availableWidgetsTableAthlete.getSelection(),
			...this.availableWidgetsTableBattleBox.getSelection(),
			...this.availableWidgetsTableBattleMMA.getSelection()
		];
		let selectedIds: number[];
		if (rows)
		{
			if (rows.length === 0)
				selectedIds = [];
			else
			{
				let ids = rows.map(x => Number.parseInt(x.Id, 10));
				if (ids.every(x => !isNaN(x)))
				{
					selectedIds = ids;
				}
			}
		}
		if (selectedIds != undefined)
		{
			ServerAPI.post(`/widget/setWidgetsForUser/${userId}`, selectedIds);
		}
	}


	setHeight(value: number)
	{
		super.setHeight(value);
		if (this._list)
			this._list.setHeight(this._Height - 64);

		this.drillCardListPanel?.setHeight(this._Height - 64);
	}

	setWidth(value: number)
	{
		super.setWidth(value);

		if (this._filtersPanel.getIsVisible())
			value = value - 280;

		if (this._list)
			this._list.setWidth(value);

		this.drillCardListPanel?.setWidth(value);
	}

	filterItems(value: string)
	{
		this._FilterText = value;
		this.refresh();
	}

	async refresh()
	{
		let request = {
			offset: this._Offset, count: this._Count,
			filterText: this._FilterText || '',
			mode: this._Mode,
			filterData: this._filtersPanel.getFilterData()
		}
		let res = this._Mode == PageMode.users ? await ServerAPI.post<UsersResponse>("/users", request):
			await ServerAPI.post<UsersResponse>("/users/players", request)

		this._list.setRows(res.users.map((item: IUserInfo) => ({
			...item,
			Name: `${item.Email} ${item.FirstName || ''} ${item.LastName || ''}`,
			HasFCM: !!item.FCMToken
		})));

		this._list.updatePagCaption(`${this._Offset + 1} - ${Math.min(this._Offset + this._Count, this._Offset + res.users.length)}`);
		this._list.getRightPagButton().setEnabled(res.users.length == this._Count);
		this._list.getLeftPagButton().setEnabled(this._Offset > 0);


		if (this._OpenedItemId != null)
			this.showCardList(this._OpenedItemId)
	}
}

interface UsersResponse
{
	users: IUserInfo[],
	allCount: number
}
